import { useEffect, useState } from "react";

let cachedData = null
let isLoading = false;

const usePlaces = () => {
    const path = "/utils/mocks/places/places.json"
    const [data, setData] = useState(cachedData);
        const [loading, setLoading] = useState(false);
        const [error, setError] = useState(false);
        
        useEffect(() => {
            if (cachedData || isLoading) return;
    
            async function fetchBooks() {
                isLoading = true;
                setLoading(true);
    
                try {
                    const response = await fetch(path);
                    const jsonData = await response.json(); 
                    cachedData = jsonData;
                    setData(jsonData);
                } catch(err) {
                    setError(err.message); 
                    setData(null);
                } finally {
                    isLoading = false;
                    setLoading(false);
                }
            }
    
            fetchBooks();
            
        }, []);
    
        return { data, loading, error };
}

export default usePlaces